import { combineReducers } from 'redux';
import app from './reducers/app';
import user from './reducers/user';
import masquerade from './reducers/masquerade';
import stats from './reducers/stats';
import recover from './reducers/recover';
import registration from './reducers/registration';

export default combineReducers({ app, user, masquerade, stats, recover, registration });